"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftResearchFlowTypeNames = exports.GiftResearchFlowType = void 0;
var GiftResearchFlowType;
exports.GiftResearchFlowType = GiftResearchFlowType;

(function (GiftResearchFlowType) {
  GiftResearchFlowType["instantGift"] = "restrict_research";
  GiftResearchFlowType["requireResearch"] = "require_research";
  GiftResearchFlowType["instantGiftOrResearch"] = "optional";
})(GiftResearchFlowType || (exports.GiftResearchFlowType = GiftResearchFlowType = {}));

var giftResearchFlowTypeNames = {
  [GiftResearchFlowType.instantGift]: 'Instant Gift',
  [GiftResearchFlowType.requireResearch]: 'Research required',
  [GiftResearchFlowType.instantGiftOrResearch]: 'Choice of Instant Gift or Research'
};
exports.giftResearchFlowTypeNames = giftResearchFlowTypeNames;